import { wrapXhr } from './xhr';
import { wrapFetch } from './fetch';

export function setupRequsetProxy() {
  wrapXhr();
  wrapFetch();
}

export function removeRequsetProxy() {
  //
}
